module.exports = __webpack_public_path__ + "static/media/benefits_health_care.6f3ae133.svg";